import React from 'react';
import { Grid, InputLabel, OutlinedInput } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { GridPanel, dataGridDefaults } from '../../../components/list-grid-panel';
import { RowAction } from '../../../components/row-action';
import { usePagedList } from '../../../hooks/use-paged-list';
import SupplierAppService from '../../../application/platform/sge/supplier/supplier-app-service';
import { formatDocument } from '../../../utils/document';
import { useSupplierSearchController } from './context/supplier-search-controller';
import { useSupplierSearchState } from './context/supplier-search-context';
import { SupplierDrawer } from './components/supplier-drawer';

export function SupplierSearchComponent() {
    const ctrl = useSupplierSearchController();
    const { parameters, searchTrigger, countries, drawer } = useSupplierSearchState();
    const { rows, rowCount, loading } = usePagedList(SupplierAppService.list, parameters, searchTrigger, 'Não foi possível carregar os fornecedores');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'personName', headerName: 'Nome', flex: 1, minWidth: 200 },
        { field: 'document', headerName: 'Documento', width: 180, sortable: false, valueGetter: (params) => formatDocument(params.row.cpf || params.row.cnpj) },
        { field: 'isActive', headerName: 'Ativo', width: 80, type: 'boolean' },
        {
            field: 'actions', headerName: 'Ações', width: 100, sortable: false,
            renderCell: (params) => (
                <React.Fragment>
                    <RowAction title="Editar" onClick={() => ctrl.openDrawer(params.row)}>
                        <EditIcon fontSize="small" />
                    </RowAction>
                    <RowAction title="Excluir" color="error" onClick={() => ctrl.handleDelete(params.row)}>
                        <DeleteIcon fontSize="small" />
                    </RowAction>
                </React.Fragment>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader title="Fornecedores" subtitle="Gerencie os fornecedores cadastrados" breadcrumbs={[{ label: 'Fornecedores' }]} />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12}>
                        <InputLabel>Buscar por nome ou documento</InputLabel>
                        <OutlinedInput fullWidth name="input-term" value={parameters.term || ''} onChange={ctrl.handleOnChange} onKeyDown={(e) => e.key === 'Enter' && ctrl.handleSearch()} />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <GridPanel addLabel="Novo fornecedor" onAdd={() => ctrl.openDrawer()}>
                    <DataGrid
                        {...dataGridDefaults}
                        rows={rows}
                        columns={columns}
                        loading={loading}
                        rowCount={rowCount}
                        paginationMode="server"
                        paginationModel={{ page: parameters.page ?? 0, pageSize: parameters.pageSize ?? 25 }}
                        onPaginationModelChange={(model) => ctrl.handlePaginationChange(model.page, model.pageSize)}
                    />
                </GridPanel>
            </Grid>

            <SupplierDrawer
                open={drawer.open}
                initial={drawer.record}
                countries={countries}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
